import React from "react";
import "./Home.css";
import Footer2 from "../Components/Footer2";
import Header from "../Components/Header";
import ParallaxSection from "./ParallaxSection";

export default function NetworkandSecurity() {
  return (
    <>
      <Header />
      <main className="page_content">
        {/* <!-- Page Banner Section - Start
        ================================================== --> */}
        <section
          className="page_banner_section text-center"
          style={{
            backgroundImage: `url(${"assets/images/site_logo/site_logo_01.jpg"})`,
            backgroundBlendMode: "overlay",
          }}
        >
          <div className="container">
            <h1 className="page_title mb-0 text-white">Network and Security</h1>
            <p className="text-white mt-2 myText">
              Network Security At NetSole, we offer a
              comprehensive suite of network security services designed to
              protect your business from the ever-increasing threats of cyber
              attacks, data breaches, and system vulnerabilities.
            </p>
          </div>
        </section>
        {/* <!-- Page Banner Section - End
        ================================================== --> */}

        {/* <!-- Service Details Section - Start
        ================================================== --> */}
        <section className="service_details_section section_space bg-light">
          <div className="container">
            <h2 className="details_item_title">
              Network Infrastructure and Design
            </h2>
            <p>
              NetSole IT solutions for businesses. We have been providing
              software and hardware solutions for both public and private sector
              clients for almost 20 years. Our solutions are powering major
              industries and stores in Ireland, Europe and beyond.At NetSole, we
              offer a comprehensive suite of network security services designed
              to protect your business from the ever-increasing threats of cyber
              attacks, data breaches, and system vulnerabilities. Our team of
              experts specializes in creating robust network infrastructures
              that not only meet current demands but also anticipate future
              needs.
            </p>
            <p>
              Our services include 3D animated network diagrams, access control
              systems, consulting and maintenance services, and data protection
              strategies. Each service is tailored to enhance your network's
              security, efficiency, and reliability, ensuring that your business
              can operate smoothly in a digital-first world.
            </p>

             <section
              class="business_consulting_service_section section_space"
              style={{
                backgroundImage: `url('assets/images/backgrounds/bg_image_04.jpg')`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "fixed",
                backgroundPosition: "center -22px",
                transformStyle: "preserve-3d",
              }}
            >
              <div class="container margincontainer">
                <div class="row justify-content-center">
                  <div class="col-lg-7">
                    <div class="heading_block text-center">
                      <h2 class="heading_text">
                        <mark style={{ color: "#543A14" }}>
                          Network Services
                        </mark>
                      </h2>
                      <p class="heading_description mb-0">
                        Netsole Offfered More than A Graphic and Designing
                        Company
                      </p>
                    </div>
                  </div>
                </div>

                <div class="business_consulting_services row">
                  <div class="col-lg-4 mycon1">
                    <div
                      class="iconbox_block mycon"
                      style={{
                        padding: "36px 55px",
                        boxShadow: "0 20px 30px 0 rgba(174, 191, 210, 0.3)",
                      }}
                    >
                      {/* <div class="iconbox_icon">
                    <img
                     src="assets/images/icons/icon_javascript.svg"
                     alt="JavaScript SVG Icon"
                    />
                  </div> */}
                      <div class="iconbox_content">
                        <h3 class="iconbox_title">
                          <a href="#" style={{ color: "#543A14" }}>
                            Network Security
                          </a>
                        </h3>
                        <p class="mb-0 myconPara">
                          Netsole delivers robust network security solutions to
                          protect against cyber threats using firewalls,
                          intrusion detection systems, and continuous threat
                          monitoring.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div
                      class="iconbox_block mycon"
                      style={{
                        height: "300px",
                        padding: "36px 55px",
                        boxShadow: "0 20px 30px 0 rgba(174, 191, 210, 0.3)",
                      }}
                    >
                      <div class="iconbox_content">
                        <h3 class="iconbox_title">
                          <a href="#" style={{ color: "#543A14" }}>
                            Network Design/Services
                          </a>
                        </h3>
                        <p class="mb-0 myconPara">
                          We design and implement scalable, high-performance
                          network infrastructures tailored to your business
                          needs, ensuring smooth and reliable connectivity.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div
                      class="iconbox_block mycon"
                      style={{
                        height: "300px",
                        padding: "36px 55px",
                        boxShadow: "0 20px 30px 0 rgba(174, 191, 210, 0.3)",
                      }}
                    >
                      <div class="iconbox_content">
                        <h3 class="iconbox_title">
                          <a href="#" style={{ color: "#543A14" }}>
                            Live Network Maps
                          </a>
                        </h3>
                        <p class="mb-0 myconPara"> 
                          Our real-time network maps offer complete visibility 
                          into your network, helping you monitor device
                          activity, detect issues instantly, and maintain
                          control.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <h3 className="details_item_info_title pt-5">Services Offered</h3>
            <div className="row mb-5 align-items-center justify-content-lg-between">
              <div className="col-lg-6">
                <div className="accordion" id="service_process_faq">
                  <div className="accordion-item pt-3">
                    <div
                      className="accordion-button"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse_one"
                      aria-expanded="true"
                      aria-controls="collapse_one"
                    >
                      01. 3D Animated Network Diagrams
                    </div>
                    <div
                      id="collapse_one"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#service_process_faq"
                    >
                      <div className="accordion-body">
                        <p className="m-0">
                          Visually engaging and interactive representations that
                          help in understanding complex network infrastructures
                          with clarity and precision.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item pt-3">
                    <div
                      className="accordion-button collapsed"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse_two"
                      aria-expanded="false"
                      aria-controls="collapse_two"
                    >
                      02. Access Control
                    </div>
                    <div
                      id="collapse_two"
                      className="accordion-collapse collapse"
                      data-bs-parent="#service_process_faq"
                    >
                      <div className="accordion-body">
                        <p className="m-0">
                          Secure systems that regulate who can access specific
                          data, devices, or network areas—ensuring only
                          authorized personnel have the right permissions.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item pt-3">
                    <div
                      className="accordion-button collapsed"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse_three"
                      aria-expanded="false"
                      aria-controls="collapse_three"
                    >
                      03. Consulting and Maintenance Services
                    </div>
                    <div
                      id="collapse_three"
                      className="accordion-collapse collapse"
                      data-bs-parent="#service_process_faq"
                    >
                      <div className="accordion-body">
                        <p className="m-0">
                          Expert guidance and routine system upkeep to ensure
                          your network runs smoothly, stays updated, and adapts
                          to new challenges.
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="accordion-item pt-3">
                    <div
                      className="accordion-button collapsed"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse_four"
                      aria-expanded="false"
                      aria-controls="collapse_four"
                    >
                      04. Data Protection
                    </div>
                    <div
                      id="collapse_four"
                      className="accordion-collapse collapse"
                      data-bs-parent="#service_process_faq"
                    >
                      <div className="accordion-body">
                        <p className="m-0">
                          Strategies and tools to safeguard sensitive
                          information from loss, theft, or unauthorized
                          access—ensuring compliance and peace of mind.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item pt-3">
                    <div
                      className="accordion-button collapsed"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse_five"
                      aria-expanded="false"
                      aria-controls="collapse_five"
                    >
                      05.   Cloud Services
                    </div>
                    <div
                      id="collapse_five"
                      className="accordion-collapse collapse"
                      data-bs-parent="#service_process_faq"
                    >
                      <div className="accordion-body">
                        <p className="m-0">
                          Netsole offers scalable and secure cloud solutions that enable businesses to store, access, and manage data and applications anytime, from anywhere. Our cloud services support seamless collaboration, reduce infrastructure costs, and ensure business continuity through reliable uptime and backup systems.
                           
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-5">
                <ul className="content_layer_group unordered_list_block text-center">
                  <li
                    className="accordion-button"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse_one"
                    aria-expanded="true"
                    aria-controls="collapse_one"
                  >
                    <span>3D Animated Network Diagrams</span>
                  </li>
                  <li
                    className="accordion-button collapsed"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse_two"
                    aria-expanded="false"
                    aria-controls="collapse_two"
                  >
                    <span>Access Control</span>
                  </li>
                  <li
                    className="accordion-button collapsed"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse_three"
                    aria-expanded="false"
                    aria-controls="collapse_three"
                  >
                    <span>Consulting and Maintenance</span>
                  </li>
                  <li
                    className="accordion-button collapsed"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse_four"
                    aria-expanded="false"
                    aria-controls="collapse_four"
                  >
                    <span>Data Protection</span>
                  </li>
                  <li
                    className="accordion-button collapsed"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse_five"
                    aria-expanded="false"
                    aria-controls="collapse_five"
                  >
                    <span>Cloud Services</span>
                  </li>
                </ul>
              </div>
            </div>

           

            <h3 className="details_item_info_title pt-5">
              {" "}
              Results Of Services
            </h3>
            <p className="mb-4">
              <strong>Key Outcomes:</strong> Our services deliver measurable
              results, enhancing your network's performance and security.
            </p>
            <div className="row mb-4">
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_04.png" />
                    </span>
                    <span className="icon_list_text">
                      Visual Clarity and Communication
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_04.png" />
                    </span>
                    <span className="icon_list_text">
                      Authorization and User Control
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_04.png" />
                    </span>
                    <span className="icon_list_text">
                      Data Integrity and Security
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_04.png" />
                    </span>
                    <span className="icon_list_text">
                      Threat Prevention and Cybersecurity
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_04.png" />
                    </span>
                    <span className="icon_list_text">
                      Customized Infrastructure and Scalability
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_04.png" />
                    </span>
                    <span className="icon_list_text">
                      Real-Time Monitoring and Network Visibility
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- Service Details Section - End
        ================================================== --> */}

        {/* <!-- Call To Action Section - Start
        ================================================== --> */}
        <ParallaxSection />
        {/* <section
          className="calltoaction_section parallaxie"
         style= {{backgroundImage: `url(${'assets/images/backgrounds/bg_image_1.webp'})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundAttachment: 'fixed', backgroundPosition: 'center -22px', transformStyle:'preserve-3d'}}
          >
          <div className="container text-center" >
            <div className="heading_block text-white">
              <h2 className="heading_text">Ready to Work, Let's Chat</h2>
              <p className="heading_description mb-0">
                Our team of experts is ready to collaborate with you every step
                of the way, from initial consultation to implementation.
              </p>
            </div>
            <a className="btn btn-primary" href="contact.html">
              <span className="btn_label" data-text="Contact Us Today!"
                >Contact Us Today!</span
              >
              <span className="btn_icon">
                <i className="fa-solid fa-arrow-up-right"></i>
              </span>
            </a>
          </div>
        </section> 
        */}

        {/* <!-- Call To Action Section - End
        ================================================== --> */}
      </main>
      <Footer2 />
    </>
  );
}

{
  /* 
                  <li
                    className="accordion-button collapsed"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse_four"
                    aria-expanded="false"
                    aria-controls="collapse_four"
                  >
                    <span>Network Security</span>
                  </li>
                  <li
                    className="accordion-button collapsed"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse_four"
                    aria-expanded="false"
                    aria-controls="collapse_four"
                  >
                    <span>Network Design and Services</span>
                  </li>
                  <li
                    className="accordion-button collapsed"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse_four"
                    aria-expanded="false"
                    aria-controls="collapse_four"
                  >
                    <span>Live Network Maps</span>
                  </li>



                  <div className="accordion-item">
                    <div
                      className="accordion-button collapsed"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse_four"
                      aria-expanded="false"
                      aria-controls="collapse_four"
                    >
                      04.  Network Security
                    </div>
                    <div
                      id="collapse_four"
                      className="accordion-collapse collapse"
                      data-bs-parent="#service_process_faq"
                    >
                      <div className="accordion-body">
                        <p className="m-0">
                        Comprehensive measures including firewalls, intrusion detection, and threat monitoring to protect networks from cyber threats.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div
                      className="accordion-button collapsed"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse_four"
                      aria-expanded="false"
                      aria-controls="collapse_four"
                    >
                      04. Network Design and Services
                    </div>
                    <div
                      id="collapse_four"
                      className="accordion-collapse collapse"
                      data-bs-parent="#service_process_faq"
                    >
                      <div className="accordion-body">
                        <p className="m-0">
                           Customized planning and implementation of network architecture that supports scalability, performance, and reliability.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div
                      className="accordion-button collapsed"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse_four"
                      aria-expanded="false"
                      aria-controls="collapse_four"
                    >
                      04. Live Network Maps
                    </div>
                    <div
                      id="collapse_four"
                      className="accordion-collapse collapse"
                      data-bs-parent="#service_process_faq"
                    >
                      <div className="accordion-body">
                        <p className="m-0">
                           Real-time visual maps of your network that allow for easy monitoring, troubleshooting, and management of all connected devices and traffic flow.
                        </p>
                      </div>
                     </div>
                  </div>

  */
}
